import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_adapt-wellness/artifacts/oi00lf58_WhatsApp%20Image%202026-01-22%20at%2018.24.42.jpeg" 
                alt="Mushhrushh Logo" 
                className="footer-logo-image"
              />
              <span className="footer-logo-text">MUSHHRUSHH</span>
            </Link>
            <p className="body-regular footer-tagline">
              Pure Adaptogens. Real Energy. No Compromise.
            </p>
          </div>

          <div className="footer-links">
            <h4 className="footer-heading">Learn More</h4>
            <ul className="footer-link-list">
              <li>
                <button onClick={() => scrollToSection('about')} className="footer-link">
                  About
                </button>
              </li>
              <li>
                <Link to="/history" className="footer-link">
                  History
                </Link>
              </li>
              <li>
                <Link to="/how-to-consume" className="footer-link">
                  How to Consume
                </Link>
              </li>
              <li>
                <Link to="/faq" className="footer-link">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <Mail size={18} className="accent-orange" />
                <span className="body-small">MUSHHRUSHH@GMAIL.COM</span>
              </div>
              <div className="footer-contact-item">
                <Phone size={18} className="accent-orange" />
                <span className="body-small">+91 9145737191</span>
              </div>
              <div className="footer-contact-item">
                <MapPin size={18} className="accent-orange" />
                <span className="body-small">Goa, India</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small">
            © {currentYear} Mushhrushh. All rights reserved. Lab-grown with care in India.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;